import { ReturnRate } from '@/ui/components/analytics-components'
import { useRegisterChatContext } from '@/ui/components/ai-chat'
import { useState } from 'react'
import { Base } from '@itsrever/design-system'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { NavigationTabs, TabProps } from '@/ui/shared'
import { AnalyticsFilterBar } from '@/ui/components/analytics-filters'

const { MonthPicker } = Base

function ProductAnalytics() {
  const { t } = useTranslation()

  useRegisterChatContext({
    tab: 'analytics',
    getPayload: () => ({ current_tab: 'analytics' })
  })

  const tabs: TabProps[] = [
    {
      copy: t('product_analytics.return_amount'),
      link: '/analytics/products'
    },
    {
      copy: t('product_analytics.return_rate'),
      link: '/analytics/products-return-rates'
    }
  ]

  const [dateFrom, setDateFrom] = useState<moment.Moment | null>(
    moment().subtract(1, 'M').startOf('month')
  )
  const [dateTo, setDateTo] = useState<moment.Moment | null>(
    moment().subtract(1, 'M').endOf('month')
  )

  return (
    <>
      <NavigationTabs tabs={tabs} selectedIndex={1} />
      <div className="flex h-full flex-col items-center overflow-y-scroll [&::-webkit-scrollbar]:hidden">
        <div className="flex w-full max-w-[1000px] items-center justify-between px-4 pt-4">
          <AnalyticsFilterBar
            startDate={dateFrom?.format('YYYY-MM-DD')}
            endDate={dateTo?.format('YYYY-MM-DD')}
          />
          <div className="w-60">
            <MonthPicker
              mode="range"
              selected={{
                from: dateFrom?.toDate(),
                to: dateTo?.toDate()
              }}
              onSelect={(range) => {
                setDateFrom(range?.from ? moment(range.from) : null)
                setDateTo(range?.to ? moment(range.to) : null)
              }}
              disabled={(month) => moment(month).isAfter(moment(), 'month')}
              placeholder={t('date_range.select_month_range')}
            />
          </div>
        </div>

        <ReturnRate
          fromDate={dateFrom?.format('YYYY-MM-DD') ?? ''}
          toDate={dateTo?.format('YYYY-MM-DD') ?? ''}
        />
      </div>
    </>
  )
}

export default ProductAnalytics
